<ft-generic-table fxFlex
                  [remote]="false"
                  [source]="source$"
                  [selectable]="false"
                  [hasPagination]="false"
                  [columns]="columns">
</ft-generic-table>
